import React from 'react';
import { SdfButton, SdfFocusPane } from '@synerg/react-components';


export default function SubscriberInfoModal({ carDetails, setShowSubscriberInfo }) {

  const SubscriberInfo = ({ label, value }) => {
    return (<div className="mt-4">
      <div className="">
        <div className="text-body-short-01 text-secondary font-medium">{label}</div>
        <div className="mt-1 mb-6 text-heading-04 font-bold">{value}</div>
      </div>
    </div>);
  };

  return (
    <SdfFocusPane
      paneType="floating"
      visible={true}
      size="small"
      closeable={true}
      hideAcceptButton={true}
      hideDismissButton={true}
      onSdfDismiss={() => setShowSubscriberInfo(false)}
    >
      <div className='mx-6'>
        <div className='text-heading-05 font-black'>Initial subscriber info</div>
        <div className='text-body-02 mt-3' style={{ fontWeight: 450 }}>
          As the initial subscriber of this application, this person is the only one authorized to provide data consent for the organization. After consent is provided by this individual, any practitioner in the org can provide authorization consent again, if needed.
        </div>
        <div className='mt-5 mb-6 text-heading-04 font-bold'>Practitioner/Purchaser contact details</div>
        <SubscriberInfo label={"Name"} value={carDetails?.subscriberInfo?.subsriberName || 'NA'} />
        <SubscriberInfo label={"Email"} value={carDetails?.subscriberInfo?.subscriberEmail || 'NA'} />
        <SubscriberInfo label={"Subscriber AOID"} value={carDetails?.subscriberInfo?.subscriberAOID || 'NA'} />
      </div>

      <SdfButton emphasis='primary' slot='custom-buttons' onClick={() => setShowSubscriberInfo(false)}>Close
      </SdfButton>

    </SdfFocusPane>
  );

}
